// extracted by mini-css-extract-plugin
module.exports = {"button":"AppMMShortlistButton_button__iSKhJ","shimmer":"AppMMShortlistButton_shimmer__lub6s"};